import type { JSX } from 'react';
import { Button, IconArrowRight, cn } from '@taki/ui';
import type { FicheSuivie } from './contexte.js';
import { IconeDeSource } from './RailDuCentre.js';
import type { SourceDeConversation } from './sources.js';

/**
 * L'EMPLACEMENT D'UNE SOURCE QUI ARRIVE (Notifications, Ici, Canaux, Messages
 * directs) : la zone 5 dit ce que c'est, et par quel chantier ca se branche.
 * Aucune donnee inventee (regle du produit : pas de fausse donnee en
 * production) ; une surface qui apprend que la fonction existe (G24), avec sa
 * raison (G16). Pour « Ici », la fiche ouverte est nommee et s'ouvre.
 */
export function EmplacementAVenir({ source, ficheOuverte, onOuvrirFiche, compact }: {
  source: SourceDeConversation;
  ficheOuverte: FicheSuivie | null;
  onOuvrirFiche?: (fiche: FicheSuivie) => void;
  compact: boolean;
}): JSX.Element {
  const titre = source.id === 'ici' && ficheOuverte ? `Ici : ${ficheOuverte.titre}` : source.libelle;
  return <div className={cn('flex min-h-0 flex-1 flex-col items-center justify-center text-center', compact ? 'px-5 py-6' : 'px-10 py-12')}>
    <span className="flex h-11 w-11 items-center justify-center rounded-full bg-surface-3 text-ink-500"><IconeDeSource id={source.id} size={20} /></span>
    <h2 className={cn('mt-3 font-semibold text-ink-900', compact ? 'text-base leading-6' : 'text-lg leading-7')}>{titre}</h2>
    <p className={cn('mt-1.5 max-w-sm text-ink-500', compact ? 'text-[0.8125rem] leading-5' : 'text-sm leading-5')}>{source.raison}</p>
    {source.id === 'ici' && ficheOuverte && onOuvrirFiche && <Button variant="secondary" size="sm" className="mt-4" onClick={() => onOuvrirFiche(ficheOuverte)}>
      Ouvrir la fiche <IconArrowRight size={13} className="-rotate-45" />
    </Button>}
  </div>;
}
